import { Directive, input } from '@angular/core';

@Directive({
	selector: '[longpress]',
	host: {
		'(touchstart)': 'touchstart()',
		'(touchend)': 'cancel()',
		'(touchmove)': 'cancel()',
		'(contextmenu)': 'contextmenu($event)',
	}
})
export class LongpressDirective {
	longpress = input.required<CallableFunction>()
	longpressDelay = input(500)

	timer = null

	touchstart() { 
		this.timer = setTimeout(() => {
			this.timer = null
			this.longpress()()
			if (window?.navigator?.vibrate) window.navigator.vibrate(100)
		}, 500)
	}

	cancel() {
		clearTimeout(this.timer)
	}

	contextmenu(event) {
		event.stopPropagation()
		event.preventDefault()
	}
}
